import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
const SuggestionList = ({ isToggled, isFocused, dropdownDirection, children }) => {
    const { borders } = useTheme();
    const dropdownStyles = useMemo(() => ({
        position: 'absolute',
        zIndex: 1,
        ...(dropdownDirection === 'up' ? { bottom: '100%' } : { top: '100%' }),
        left: `-${borders.base.borderWidth}`,
        width: '100%',
        minHeight: '100%',
        boxSizing: 'content-box',
        borderRadius: dropdownDirection === 'up' ? '2.6rem 2.6rem 0 0' : '0 0 2.6rem 2.6rem',
        ...borders.base,
        ...(!isFocused && !isToggled && borders.variant.secondary)
    }), [borders, dropdownDirection, isFocused, isToggled]);
    if (!isToggled || !children)
        return null;
    return (React.createElement("div", { style: dropdownStyles, "data-testid": "combolist" }, children));
};
export default SuggestionList;
//# sourceMappingURL=SuggestionList.js.map